export default "__VITE_ASSET__B2Cb_ouH__"